import React, { useState } from 'react';
import { IconButton } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';

const SyncButton = ({ onSync, disabled }) => {
  const [isSyncing, setIsSyncing] = useState(false);

  const handleClick = async () => {
    setIsSyncing(true);
    try {
      await onSync();
    } finally {
      setIsSyncing(false);
    }
  };

  return (
    <IconButton
      onClick={handleClick}
      disabled={disabled || isSyncing}
      color="primary"
      title="Sync organization"
      size="small"
      sx={{
        '@keyframes spin': {
          from: { transform: 'rotate(0deg)' },
          to: { transform: 'rotate(360deg)' },
        },
      }}
    >
      <RefreshIcon
        sx={{
          fontSize: 20,
          ...(isSyncing && {
            animation: 'spin 1s linear infinite',
          }),
        }}
      />
    </IconButton>
  );
};

export default SyncButton;
